import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { forbidExtraProps } from "utils";
import { CONTENT } from "consts";
import { toggleEncryptionType, changeEncryptionKey } from "store/actions";

function Encryption(props) {
  let encryptionTypes = [];

  for (const key in props.enums.EncryptionType.props) {
    const item = props.enums.EncryptionType.props[key];
    const intKey = parseInt(key);

    encryptionTypes.push(
      <div key={intKey} className="mse_item">
        <label className="radio_container">
          <input
            type="radio"
            className="input_radio"
            name="radio_encryption"
            id={item.name}
            checked={props.encryption.type === intKey}
            onChange={() => props.toggleEncryptionType(intKey)}
          />
          <span className="radio_checkmark" />
          <span className="fs_16">
            {CONTENT.backupSettings.encryption[item.key].title}
          </span>
        </label>
        <p>{CONTENT.backupSettings.encryption[item.key].brief}</p>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="main_summary_encryption">
        <div className="main_summary_encryption__inner">
          {encryptionTypes}

          <div className="encryption_key">
            <div className="ekey_item">
              <p>{CONTENT.backupSettings.encryption.key.value}</p>
              <div className="input_field_msg">
                <div>
                  <input
                    type="text"
                    className="input_text"
                    value={props.encryption.key.value}
                    onChange={e =>
                      props.changeEncryptionKey("value", e.target.value)
                    }
                  />
                </div>
                {/* <span className="error-msg">
                  Please enter proper encryption key
                </span> */}
              </div>
            </div>
            <div className="ekey_item">
              <p>{CONTENT.backupSettings.encryption.key.confirmValue}</p>
              <div className="input_field_msg">
                <div>
                  <input
                    type="text"
                    className="input_text"
                    value={props.encryption.key.confirmValue}
                    onChange={e =>
                      props.changeEncryptionKey("confirmValue", e.target.value)
                    }
                  />
                </div>
                {/* <span className="error-msg">
                  Please enter proper encryption key
                </span> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="encryption_warning">
        <p className="global_color sub_title">WARNING</p>
        <ul className="encryption_warning_ul">
          {CONTENT.backupSettings.encryptionWarning.map((val, i) => (
            <li key={i}>{val}</li>
          ))}
        </ul>
      </div>
    </React.Fragment>
  );
}

Encryption.propTypes = forbidExtraProps(
  {
    encryption: PropTypes.shape({
      type: PropTypes.oneOf([0, 1]).isRequired,
      key: PropTypes.object
    }).isRequired
  },
  ["enums", "toggleEncryptionType", "changeEncryptionKey"]
);

function mapStateToProps(state) {
  return {
    encryption: state.backupSettings.encryption,
    enums: state.common.enums
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleEncryptionType,
      changeEncryptionKey
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Encryption);
